var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightVisualHeader = function SvgArrowRightVisualHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-icon, black)",
    strokeWidth: 2,
    d: "M36 19H0M21.717 1.257l17.964 16.174M21.501 36.592l17.964-16.175",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgArrowRightVisualHeader;